export const endpointsURL = {
  usuarioMantenimientoURL: "/admsistema/user",
  historicoBastidorURL: "/admdatos/historicoplaca",
  importDatosAccesorios: "/admdatos/edit",
  exportHistoricoBastidor: "/admdatos/ExportHistoricoPlaca/edit/download",
  maintenanceConcessionaireURL: "/concesionario/edit",
  maintenanceMastertablesURL: "/admdatos/mastertable/",
  permisosTablaURL: "/permisostabla/",
  maintenanceTemplatesURL: "/admsistema/plantillas/edit",
  maintenancePatronWltpURL: "/admdatos/datowltp/edit",
  authURL: "/auth/",
  listsValuesConcesionariosURL: "/concesionarios",
  listsValuesPerfilesURL: "/perfiles",
  listValuesTiposDeDocumentoURL: "/tipodocumento/lista",
  listValuesTiposDeDocumentoSimpleURL: "/tipodocumento/listasimple",
  listValuesPlantillasActivasURL: "/plantillasactivas/lista",
  listValuesEtiquetasURL: "/etiquetas/",
  listValuesFabricantesURL: "/fabricantes/lista",
  listValuesFormatosImpresionURL: "/formatosimpresion/lista",
  listValuesMarcasURL: "/marcas/lista",
  listValuesAnalistasURL: "/analistas/lista",
  listValuesAnalistasActivosURL: "/analistasActivos/lista",
  listValuesAnalistasBuzonURL: "/analistasBuzon/lista",
  listValuesAnalistasBuzonCocURL: "/analistasBuzonCoc/lista",
  listValuesAnalistasConsultaCocURL: "/analistasConsultaCoc/lista",
  listValuesCertificatesURL: "/certificados/list",
  listValuesEstadosURL: "/estados/list",
  listValuesReformsURL: "/reforma/list",
  listValuesReformsPadreURL: "/reforma/listconpadre",
  listValuesUsersURL: "/usuarios",
  listValuesMotorURL: "/motor/lista",
  listValuesTipoVehiculoURL: "/tipoVehiculos/lista",
  listValuesMotivosRechazoURL: "/motivos/lista",
  listValuesCamposLI: "/camposLI/list",
  listValuesEstadosPorPantalla: "/estados/listaPantalla",
  printFormatsURL: "/admsistema/formatoimpresion/",
  maintenanceTemplatesRulesURL: "/reglasplantilla/edit",
  maintenanceReformsURL: "/admsistema/tiporeforma/",
  maintenancePrintsParamsURL: "/admsistema/printerfile",
  maintenancePrintsRulesURL: "/admsistema/reglasimpresion/",
  maintenanceDataCDTURL: "/admdatos/datocdt/edit",
  maintenanceAvailableFieldsRoyalDecree: "/admsistema/availablefield/",
  maintenanceSpecificFieldsRoyalDecree: "/admsistema/decreelaw",
  changePasswordURL: "/admsistema/contrasena/",
  personalConfigurationURL: "/admsistema/paramPersonal/edit",
  mailBoxRulesURL: "/reglasBuzon/edit",
  solicitudCertificadoServiceURL: "/certificados/buzon",
  ayudasGeneralesURL: "/ayudas-generales",
  descargasFicheroConcesionario: "/concesionario",
  certificatesURL: "/certificados/",
  cocMailBoxURL: "/coc/",
  placaURL: "/placa/",
  estadisticasURL: "/estadisticas/",
  compareVersionsURL: "/CompareVersions/PeticionVersion",
  requestURL: "/certificateRequest/edit",
  anchoNeumaticoURL: "/camposEspecificos/AnchoNeumatico",
  perfilNeumaticoURL: "/camposEspecificos/PerfilNeumatico",
  indiceCargaURL: "/camposEspecificos/SimbolosIndiceCarga",
  simbolosIndiceVelocidadURL: "/camposEspecificos/SimbolosIndiceVelocidad",
  diametroNeumaticoURL: "/camposEspecificos/DiametroNeumatico",
  gargantaNeumaticoURL: "/camposEspecificos/GargantaNeumatico",
  bombeoNeumaticoURL: "/camposEspecificos/BombeoNeumatico",
  motoresURL: "/camposEspecificos/Motores",
  clasificacionesURL: "/camposEspecificos/Clasificaciones",
  categoriasURL: "/camposEspecificos/Categorias",
  specificFieldsURL: "/camposEspecificos/",
  listModeloURL: "/placa/reedicion/modelos",
  listTiposMotorURL: "/placa/reedicion/tiposMotor",
  listTipoCambioURL: "/placa/reedicion/tcambio",
  listBastidoresCOCURL: "/bastidores/coc/lista",
  listHBastidoresCOCURL: "/hbastidores/coc/lista",
  listMotivosReedicion: "/placa/reedicion/motivosReedicion",
  listTipoPlaca: "/fabricantes/lista",
  changeStatesPetitions: "/cambiosEstado/edit/tramitacion/",
  statesPetitionsTransitables: "/estados/estadosTransitables",
  download: "/descargas/",
  downloadReportURL: "/admsistema/user/download/",
  admDatosURL: "/admdatos/",
  tramitacionURL: "/tramitacion/",
  advancedFiltersURL: "/filtrosavanzados/",
  genericoURL: "/generico",
  camposValoresLI: "/campovalor/",
  fsplacaURL: "/fsPlaca/",
};
